import { queryClient } from '../queryClient';
import { setSelectedOrganisationId, setToken } from '../session';
import { supabase } from '../supabase';

/**
 * Ends this browser's session: revokes the Supabase refresh token and removes
 * its stored session (otherwise the next page load restores it), then clears
 * the app token, org selection and cached data. Local state is cleared even if
 * the network call fails, so the user is never left signed in.
 */
export async function signOut(): Promise<void> {
  try {
    await supabase?.auth.signOut({ scope: 'local' });
  } catch {
    /* fall through: local sign-out must still happen */
  }
  setToken(null);
  setSelectedOrganisationId(null);
  queryClient.clear();
}
